import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { IService } from "shared/models/service.model";
import { HistoryData } from "./history";
import { Utilities } from "./utilities";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class ServiceService {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private utilities: Utilities,
    private tracking: TrackingProvider,
  ) { }

  public createOrUpdate(clientId: string, service: any, eventId: string) {
    if (service.id === "") {
      this.action = "create";
      service.id = this.afDb.createPushId();
      service.created_at = new Date().getTime();
    } else {
      this.action = "update";
      service.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/Services/${service.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Services/${service.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(reference)
        .update(service)
        // .then(() => {
        //   return this.historyData.set(
        //     `Service content`,
        //     "services",
        //     this.action,
        //     service,
        //   );
        // })
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.services, service.id, clientId, eventId, service, "Creacion/actualizacion service");
          resolve(service);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public createOrUpdateGroups(clientId: string, group: any, eventId: string) {
    if (group.id === "") {
      this.action = "create";
      group.id = this.afDb.createPushId();
      group.created_at = new Date().getTime();
    } else {
      this.action = "update";
      group.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/ServiceGroups/${group.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/ServiceGroups/${group.id}`;
    }
    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(reference)
        .update(group)
        .then(() => resolve(group))
        .catch((error) => {
          reject(error);
        });
    });
  }

  public get(clientId: string, eventId: string): Observable<IService[]> {
    let reference = `Clients/${clientId}/Interactivity/Services`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Services`;
    }
    return this.afDb.list<IService>(reference).valueChanges();
  }

  public getActive(clientId: string, eventId: string): Observable<IService[]> {
    let reference = `Clients/${clientId}/Interactivity/Services`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Services`;
    }
    return this.afDb.list<IService>(
      reference,
      (ref) => ref.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getGroupsActiveByClientId(clientId: string, eventId: string): Observable<any[]> {
    let reference = `Clients/${clientId}/Interactivity/ServiceGroups`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/ServiceGroups`;
    }
    return this.afDb.list<any>(
      reference,
      (ref) => ref.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getGroupById(clientId: string, groupId: string, eventId: string): Observable<any> {
    let reference = `Clients/${clientId}/Interactivity/ServiceGroups/${groupId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/ServiceGroups/${groupId}`;
    }
    return this.afDb
      .object<any>(reference)
      .valueChanges();
  }

  public getById(clientId: string, serviceId: string, eventId: string): Observable<IService> {
    let reference = `Clients/${clientId}/Interactivity/Services/${serviceId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Services/${serviceId}`;
    }
    return this.afDb
      .object<IService>(reference)
      .valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/providers/services.service.ts